export const MAPTYCS_CHART_COLOR = "#1855F1";
export const COPERNICUS_RED_COLOR = "#C62828";
export const HISTORICAL_COLOR = "#999999";  // Dark grey for historical data

// SSP scenario color mapping - IPCC official color scheme
export const SSP_COLOR_MAP: { [key: string]: string } = {
    'SSP1 1.9': '#34b2d5',  // Cyan/Light blue (IPCC)
    'SSP119': '#34b2d5',     // Alternative format
    'SSP1-1.9': '#34b2d5',   // Alternative format
    'SSP1 2.6': '#52446e',  // Dark blue/purple (IPCC)
    'SSP126': '#52446e',     // Alternative format
    'SSP1-2.6': '#52446e',   // Alternative format
    'SSP2 4.5': '#eba040',  // Orange (IPCC)
    'SSP245': '#eba040',     // Alternative format
    'SSP2-4.5': '#eba040',   // Alternative format
    'SSP3': '#d04c27',      // Red (IPCC)
    'SSP370': '#d04c27',     // Alternative format
    'SSP3-7.0': '#d04c27',   // Alternative format
    'SSP5 8.5': '#991621',  // Dark maroon/red (IPCC)
    'SSP585': '#991621',     // Alternative format
    'SSP5-8.5': '#991621'    // Alternative format
};

/**
 * Get color for SSP scenario based on series key
 * @param seriesKey - The series key (e.g., "SSP1 1.9", "SSP1 2.6", etc.)
 * @returns Color hex code for the scenario
 */
export function getSSPColor(seriesKey: string): string {
    const normalizedKey = seriesKey.trim();
    
    // Handle Historical data explicitly - return dark grey
    if (normalizedKey.toLowerCase() === 'historical') {
        return HISTORICAL_COLOR;
    }
    
    // Try direct match first (case-insensitive)
    if (SSP_COLOR_MAP[normalizedKey]) {
        return SSP_COLOR_MAP[normalizedKey];
    }
    
    // Try case-insensitive match
    const upperKey = normalizedKey.toUpperCase();
    for (const [sspKey, color] of Object.entries(SSP_COLOR_MAP)) {
        if (sspKey.toUpperCase() === upperKey) {
            return color;
        }
    }
    
    // Try partial matches for flexibility
    for (const [sspKey, color] of Object.entries(SSP_COLOR_MAP)) {
        if (normalizedKey.includes(sspKey) || sspKey.includes(normalizedKey) ||
            normalizedKey.toLowerCase().includes(sspKey.toLowerCase()) ||
            sspKey.toLowerCase().includes(normalizedKey.toLowerCase())) {
            return color;
        }
    }
    
    // Default to the base red color
    return COPERNICUS_RED_COLOR;
}
export const MaptycsTheme = {
    color: [
        "#D3E1FF",
        "#A1BAFF",
        "#6A98FB",
        "#3C76F6",
        MAPTYCS_CHART_COLOR,
    ],

    title: {
        fontWeight: "normal",
        color: MAPTYCS_CHART_COLOR,
    },

    visualMap: {
        color: ["#D3E1FF", MAPTYCS_CHART_COLOR],
    },

    toolbox: {
        color: [
            MAPTYCS_CHART_COLOR,
            MAPTYCS_CHART_COLOR,
            MAPTYCS_CHART_COLOR,
            MAPTYCS_CHART_COLOR,
        ],
    },

    tooltip: {
        backgroundColor: "rgba(0,0,0,0.5)",
        axisPointer: {
            type: "line",
            lineStyle: {
                color: MAPTYCS_CHART_COLOR,
                type: "dashed",
            },
            crossStyle: {
                color: MAPTYCS_CHART_COLOR,
            },
            shadowStyle: {
                color: "rgba(200,200,200,0.3)",
            },
        },
    },

    dataZoom: {
        dataBackgroundColor: "#eee",
        fillerColor: "rgba(24, 85, 241, 0.2)",
        handleColor: MAPTYCS_CHART_COLOR,
    },

    timeline: {
        lineStyle: {
            color: MAPTYCS_CHART_COLOR,
        },
        controlStyle: {
            color: MAPTYCS_CHART_COLOR,
            borderColor: MAPTYCS_CHART_COLOR,
        },
    },

    candlestick: {
        itemStyle: {
            color: MAPTYCS_CHART_COLOR,
            color0: "#6A98FB",
        },
        lineStyle: {
            width: 1,
            color: MAPTYCS_CHART_COLOR,
            color0: "#6A98FB",
        },
        areaStyle: {
            color: MAPTYCS_CHART_COLOR,
            color0: "#3C76F6",
        },
    },

    chord: {
        padding: 4,
        itemStyle: {
            color: MAPTYCS_CHART_COLOR,
            borderWidth: 1,
            borderColor: "rgba(128, 128, 128, 0.5)",
        },
        lineStyle: {
            color: "rgba(128, 128, 128, 0.5)",
        },
        areaStyle: {
            color: "#3C76F6",
        },
    },

    graph: {
        itemStyle: {
            color: MAPTYCS_CHART_COLOR,
        },
        linkStyle: {
            color: "#6A98FB",
        },
    },

    map: {
        itemStyle: {
            color: MAPTYCS_CHART_COLOR,
        },
        areaStyle: {
            color: "#D3E1FF",
        },
        label: {
            color: MAPTYCS_CHART_COLOR,
        },
    },

    gauge: {
        axisLine: {
            lineStyle: {
                color: [
                    [0.2, "#dddddd"],
                    [0.8, MAPTYCS_CHART_COLOR],
                    [1, "#D3E1FF"],
                ],
                width: 8,
            },
        },
    },
};
